import { render, staticRenderFns } from "./MainLedgerIndex.vue?vue&type=template&id=0ad1950a&scoped=true"
import script from "./MainLedgerIndex.vue?vue&type=script&lang=js"
export * from "./MainLedgerIndex.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerIndex.vue?vue&type=style&index=0&id=0ad1950a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad1950a",
  null
  
)

export default component.exports